module.exports = __webpack_public_path__ + "static/media/icon-github.68505264.svg";